import React from 'react'
import ImageHeader from '../../component/ImageHeader'
import ContactForm from './ContactForm'
import { Link } from 'react-router-dom'
import ContactHead from './ContactHead'

export default function Contact() {
    const imageHead = {
        title: 'Your pathway to a soulful paradise of calm and quiet joy.',
        image: "../image/about-banner.webp",
        breadcrumb: [
            {
                name: "Contact Us",
            },
        ]
    }

    const quoteHead = {
        desc: "The water rests in warmth, your room prepared with quiet intention; we await your arrival in De Coracao with calm anticipation. If you seek the path that leads you here, reach out and let us gently guide your journey.",
        title: "An Overview",
    };

    return (
        <>
            <ImageHeader imageHead={imageHead} />
            <ContactHead quoteHead={quoteHead} />

            <section className="contactpage-address">
                <div className="container">
                    <div className="row align-items-center">

                        <div className="col-lg-6 col-md-6 order-2 order-lg-1 order-md-1">
                            <div className='image-frame'>
                                <img src="/image/contact-address.webp" className="img-responsive" alt="contact" loading="lazy" />
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6 order-1 order-lg-2 order-md-2">
                            <div className="contact-addressbox wow animate__animated animate__slideInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                <h1 className='heading'>Contact Resort De Coracao</h1>
                                <p>Below are our address and, in case of questions, our contact details.</p>

                                <span>Resort De Coracao (Goa)</span>
                                <p>Goa - 120/5 Gaura Vaddo Calangute, Goa- 403516</p>
                                <Link to="tel:+91 9552551356">+91 955255 1356</Link>

                                <span>Resort De Coracao (Corbett)</span>
                                <p>Corbett - Khasra No- 67 Savalde west Dhela Road Ramnagar, Nainital Uttarakhand -244715 (India)</p>
                                <Link to="tel:+91 7536811188">+91 753681 1188</Link>

                                <span>Resort De Coracao (Rishikesh)</span>
                                <p>Laxman Jhula Road Tapovan Rishikesh 249137 Uttarakhand</p>
                                <Link to="tel:+91 8796241980">+91 879624 1980</Link>

                                <div>
                                    <Link to="mailto:reservation@resortdecoracao.com">reservation@resortdecoracao.com</Link>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <section className="contactpage-map">
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                             {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3475.905679457674!2d79.04298771216432!3d29.40231516282979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390a15be59ff89ed%3A0x30495184db03c690!2sResort%20De%20Coracao%20-Corbett!5e0!3m2!1sen!2sin!4v1774869167693!5m2!1sen!2sin" width="100%" allowFullScreen="" loading="lazy" title="Resort De Coracao" referrerPolicy="no-referrer-when-downgrade"></iframe> */}

                            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=11rFO5VL4OoLVgivgfNvsvLj1AhOjTsY&ehbc=2E312F&noprof=1" loading="lazy" title="Resort De Coracao" width="100%"></iframe>
                        </div>
                    </div>
                </div>
            </section>

            <ContactForm />

            <section className="contactpage-include">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12">
                            <div className='contact-include-image'>
                                <img src="/image/contact-include-1.webp" className="img-responsive wow animate__animated animate__slideInLeft" data-wow-delay="0.2s" data-wow-duration="1.3s" alt="contact" loading="lazy" />

                                <img src="/image/contact-include-2.webp" className="img-responsive wow animate__animated animate__slideInRight" data-wow-delay="0.2s" data-wow-duration="1.3s" alt="contact" loading="lazy" />

                                <div className='contact-include-box'>
                                    <h3 className='heading'>So Much Included!</h3>
                                    <p>So many feel good elements. Find out everything important here.</p>

                                    <span>Included services & useful information</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}
